module.exports = __webpack_public_path__ + "static/img/equinoctial-frame.adc691a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equinoctial-frame.png
// module id = xyR/
// module chunks = 0